import api from "@/services/api.service";
export default {
  name: 'show-result',
  components: {},
  props: {
      caption: {
          type: String,
          default: 'Campaign list'
      },
      hover: {
          type: Boolean,
          default: true
      },
      striped: {
          type: Boolean,
          default: true
      },
      bordered: {
          type: Boolean,
          default: false
      },
      small: {
          type: Boolean,
          default: false
      },
      fixed: {
          type: Boolean,
          default: false
      }
  },
  data () {
    return {
        newRecords: [],
        conflictRecords: [],
        updatedRecords: [],
        fields: [
            {key: 'first_name',sortable: true},
            {key: 'email',sortable: true},
            {key: 'phone',sortable: true},
            {key: 'address',sortable: true},
            {key: 'status',sortable: true},
            {key:'actions'}
        ],
        currentUpdatedPage: 1,
        currentNewPage: 1,
        currentConflictPage: 1,
        perNewPage: 10,
        perConflictPage: 10,
        perUpdatedPage: 10,
        totalNewRecords: 0,
        totalConflictRecords: 0,
        totalUpdatedRecords: 0,
        status :'new',
        totalRecords:null,
        isBusy:true
    }
  },
  computed: {

  },
  mounted () {

  },
    created(){
        this.getResultData('new');
    },
    watch: {
        currentNewPage: {
            handler: function(page) {
                this.getResultData('new',page)
            }
        },
        currentConflictPage: {
            handler: function(page) {
                this.getResultData('conflict',page)
            }
        },
        currentUpdatedPage: {
            handler: function(page) {
                console.log(page)
               // this.getResultData('updated',page)
            }
        }
    },
  methods: {
      makeToast(message = '',title='Alert',variant='warning') {
          this.toastCount++
          this.$root.$bvToast.toast(message, {
              title:title,
              variant:variant,
              autoHideDelay: 3000
          })
      },
     async getResultData(status,page=1){
          let response = await api.post('contact/list',{'status':status,'page':page});
          if(!response)
              this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

              if(response.status=='success'){
                  if(response.data != '')
                  {
                      if(status=='new')
                      {
                          this.newRecords = response.data.data;
                          this.totalNewRecords=response.data.total;
                          this.currentNewPage=response.data.current_page;
                          this.perNewPage=response.data.per_page;
                      }else if(status=='conflict')
                      {
                          this.conflictRecords = response.data.data;
                          this.totalConflictRecords=response.data.total;
                          this.currentConflictPage=response.data.current_page;
                          this.perConflictPage=response.data.per_page;
                      }else (status=='updated')
                      {
                          this.updatedRecords = response.data.data;
                          this.totalUpdatedRecords=response.data.total;
                          this.currentUpdatedPage=response.data.current_page;
                          this.perUpdatedPage=response.data.per_page;
                      }

                  }else{
                      if(status=='new')
                          this.newRecords = []
                      else if(status=='conflict')
                          this.conflictRecords = []
                      else (status=='updated')
                          this.updatedRecords = []
                  }
              }
         this.isBusy=false;
      },
      getRowCount (items) {
          return items.length
      },
    editContact(item) {
        this.$router.push({name: 'Edit Contact', params: {id: item.item.id}})
    },
      showConfirmBox(id,index,status) {
          this.$bvModal.msgBoxConfirm('Are you sure want to delete this contact?')
              .then(value => {
                  if(value){
                      this.deleteContact(id,index,status)
                  }else{
                      return;
                  }
              })
              .catch(function () {
                  return;
              })
      },
      async deleteContact(id,index,status) {
          let response = await api.post('contact/delete', {"id": id});
          if (!response)
              this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

          if (response.status == 'success') {
              if(status=='new'){
                  this.newRecords.splice(index,1);
              } else {
                  this.allRecords.splice(index,1);
              }

              this.makeToast(response.message || `Contact delete successful.`, 'Alert', 'success')
          } else
              this.makeToast(`Contact not deleted.`, 'Alert', 'danger')
      },
  }
}


